import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-filter-placeholder-dropdown',
  templateUrl: './filter-placeholder-dropdown.component.html',
  styleUrls: ['./filter-placeholder-dropdown.component.scss']
})
export class FilterPlaceholderDropdownComponent implements OnChanges {
  UniqueId: string = uuidv4();

  private _dataArray: any[] = [];

  @Input()
  set DataArray(value: any[] | undefined) {
    this._dataArray = value ? [...value] : [];
  }
  get DataArray(): any[] {
    return this._dataArray;
  }

  @Input()
  KeyName: string[] = [];

  @Input()
  KeyId: string = "";

  @Input()
  TranslateKey: string = "";

  @Input()
  Placeholder: string = "";

  @Input()
  Loading: boolean = false

  @Input()
  Error: boolean = false;

  @Input() SelectedObject: any[] = [];  //  <-- AHORA ES UN ARRAY

  @Input()
  ShowAbsolute: boolean = true;

  @Input() useIdAsModel: boolean = false; // New: use when only the selected item's ID is provided, not the full object

  @Input() ScrollParentId: string = ""

  @Input() ScrollChildId: string = ""

  @Input() disabled: boolean = false;

  /** NEW: lets the component accept primitive arrays */
  @Input() primitiveMode: boolean = false;

  @Input() dropdownWidth: string = '100%'

  @Input() notMultiple: boolean = false;

  @Output()
  optionEmitter = new EventEmitter();

  OpenDropdown = false;

  selectedItems: any[] = [];


  ngOnChanges(changes: SimpleChanges) {
    if (changes['DataArray']) {

      if (this.primitiveMode) {
        this.KeyId = 'value';
        this.KeyName = ['value'];

        // IMPORTANTE → usar _dataArray, no this.DataArray
        this._dataArray = this._dataArray.map(value =>
          typeof value === 'object' && value?.value !== undefined
            ? value // ya está envuelto
            : { value }
        );
      }
    }

    if (changes['SelectedObject'] || changes['DataArray']) {
      this.updateSelectedItems();
    }
  }

  private updateSelectedItems() {

    // MODO 1 — primitive puro
    if (this.primitiveMode) {
      this.selectedItems = this._dataArray.filter(item =>
        this.SelectedObject?.includes(item[this.KeyId])
      );
      return;
    }

    // MODO 2 — objetos completos
    if (!this.useIdAsModel) {
      this.selectedItems = this._dataArray.filter(item =>
        this.SelectedObject?.some(sel => sel[this.KeyId] === item[this.KeyId])
      );
      return;
    }

    // MODO 3 — useIdAsModel = true (IDs pero DataArray son objetos)
    this.selectedItems = this._dataArray.filter(item =>
      this.SelectedObject?.includes(item[this.KeyId])
    );
  }

  // private useSimpleValueSelection(): boolean {
  //   return this.primitiveMode;
  // }

  setLoadingStatus() {
    if (this.Loading) {
      this.OpenDropdown = false;
    }
  }

  toggleDropdown() {
    if (!this.Loading && !this.disabled) {
      this.OpenDropdown = !this.OpenDropdown;
    }
  }

  selectOption(option: any) {
    const idValue = option[this.KeyId];

    if (this.notMultiple) {
      this.optionEmitter.emit(option);
      return
    }

    // MODO 1 — primitive
    if (this.primitiveMode) {

      if (this.SelectedObject.includes(idValue)) {
        this.SelectedObject = this.SelectedObject.filter(v => v !== idValue);
      } else {
        this.SelectedObject = [...this.SelectedObject, idValue];
      }

    }

    // MODO 2 — objetos completos
    else if (!this.useIdAsModel) {

      const exists = this.SelectedObject.some(v => v[this.KeyId] === idValue);

      if (exists) {
        this.SelectedObject = this.SelectedObject.filter(v => v[this.KeyId] !== idValue);
      } else {
        this.SelectedObject = [...this.SelectedObject, option];
      }

    }

    // MODO 3 — useIdAsModel = true
    else {
      if (this.SelectedObject.includes(idValue)) {
        this.SelectedObject = this.SelectedObject.filter(v => v !== idValue);
      } else {
        this.SelectedObject = [...this.SelectedObject, idValue];
      }
    }

    this.updateSelectedItems();

    // Emitir lista completa
    this.optionEmitter.emit(this.SelectedObject);
  }

  isSelected(item: any): boolean {

    const idValue = item[this.KeyId];

    if (this.primitiveMode || this.useIdAsModel) {
      return this.SelectedObject?.includes(idValue);
    }

    return this.SelectedObject?.some(v => v[this.KeyId] === idValue);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Verifica si el clic ocurrió dentro del dropdown usando el id único
    const element = document.getElementById(`${this.UniqueId}`);

    if (element && !element.contains(targetElement)) {
      this.OpenDropdown = false;
    }

  }


}

